<template>
    <div class="page-wrapper" id="pageWrapper">
        <div class="page-body-wrapper">
            <div class="page-body">
                <div class="container">
                    <GalleryProducts />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref, watch, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { useHead } from '@unhead/vue';
import axios from '@/utils/axiosConfig';
import GalleryProducts from '@/components/homepage/GalleryProducts.vue';

export default {
    name: 'Gallery',
    components: {
        GalleryProducts,
    },
    setup() {
        const category = ref({});
        const route = useRoute();

        const getMetaData = () => {
            const keywords = category.value.keywords 
                ? category.value.keywords 
                : generateKeywords(category.value.details || 'ecommerce, ethnic meal, quality category' );

            useHead({
                title: category.value.seo_title || category.value.name || 'Product Catalog - Ethnic Meal',
                meta: [
                    { name: 'description', content: category.value.details || 'Discover amazing categories at Ethnic Meal.' },
                    { name: 'keywords', content: keywords},
                    { property: 'og:url', content: `https://ethnicmeal.com/gallery/${category.value.slug}` },
                    { property: 'og:type', content: 'category' },
                    { property: 'og:site_name', content: 'Ethnic Meal' },
                    { property: 'og:title', content: category.value.name || 'Category Page' },
                    { property: 'og:description', content: category.value.details || 'Explore details of the category.' },
                    { property: 'og:image', content: category.value.image || '/default-image.jpg' },
                    { name: 'twitter:card', content: 'summary_large_image' },
                    { name: 'twitter:title', content: category.value.name || 'Category Page' },
                    { name: 'twitter:description', content: category.value.details || 'Explore amazing category.' },
                    { name: 'twitter:image', content: category.value.image || '/default-image.jpg' },
                ],
            });
        };

       
        const generateKeywords = (details) => {
            if (!details) return '';

            const stopWords = ['the', 'is', 'at', 'of', 'on', 'and', 'to', 'in', 'for', 'a', 'with', 'as', 'by', 'that', 'this']; // Add more stop words as needed
            const words = details.split(/\s+/); // Split details into words
            const keywords = words.filter(word => !stopWords.includes(word.toLowerCase())); // Filter out stop words

            return Array.from(new Set(keywords)).join(', '); // Unique keywords
        };
        // Fetch category data
        const getCategory = async (slug) => {
            try {
                const response = await axios.get("slug-wise-category?category_name=" + slug);
                if (response.data.success) {
                    // console.log(response.data.data)
                    category.value = response.data.data;
                } else {
                    console.error("URL Data Not Found");
                }
            } catch (error) {
                console.error("Error fetching category data:", error);
            }
        };

        onMounted(() => {
            getCategory(route.params.slug);
        });

         watch(category, (newVal) => {
            if (Object.keys(newVal).length > 0) {
                getMetaData();
            }
        });

        return {
            category,
        };
    },
};

</script>
